import { useSession } from '@/context/SessionProvider'
import { Flex, Text } from '@chakra-ui/react'
import { WithClient } from '@/components/HOC/WithClient'
import { SkeletonStyledTable, StyledTable } from '@/components/molecules/StyledTable/StyledTable'
import CrownIcon from '@/public/assets/icons/crown.svg'
import { useQuery } from '@apollo/client'
import { NoResultsFallback } from '@/components/molecules/NoResultsFallback/NoResultsFallback'
import { LAST_ROULETTE_GAMES_QUERY } from '@/api/query'
import { transformDoubleGames } from '@/helpers/transformDoubleGames'
import { useDoubleStore } from '@/context/DoubleProvider'
import { useEffect } from 'react'
import { useTranslation } from 'next-i18next/pages'

export const DoubleHistoryBets = () => {
  const { t } = useTranslation()
  const { account } = useSession()

  if (!account?.injectiveAddress) {
    return null
  }

  return (
    <>
      <Flex gap={2} alignItems={'center'} mb={4}>
        <CrownIcon />
        <Text fontWeight={700}>{t('common.last-games')}</Text>
      </Flex>
      <WithClient fallback={() => <SkeletonStyledTable numberOfRows={6} />}>
        <DoubleHistoryBetsTable />
      </WithClient>
    </>
  )
}

const DoubleHistoryBetsTable = () => {
  const { account } = useSession()
  const id = useDoubleStore((x) => x.id)

  const { data, fetchMore } = useQuery(LAST_ROULETTE_GAMES_QUERY, {
    skip: account?.injectiveAddress == undefined,
    variables: { address: account?.injectiveAddress || '' },
  })

  useEffect(() => {
    setTimeout(() => {
      fetchMore({ variables: { limit: 1 } })
    }, 1000)
  }, [id])

  const games = transformDoubleGames(data?.doubleUserGames?.edges, account?.injectiveAddress || '').slice(0, 7)

  if (!games?.length) {
    return <NoResultsFallback />
  }

  return <StyledTable games={games} />
}
